// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"19":"fe10ef6b","411":"28efc64e"}[chunkId] + ".css";
};